module.exports = __webpack_public_path__ + "media/images/favicons/greenpeace-9d65ff74087a5ea428b29e8a9d83064bc33bb16dd6ed9e9f2cff72b116e22e68.ico";